import { render, staticRenderFns } from "./EmptyBox.vue?vue&type=template&id=2121d694&"
import script from "./EmptyBox.vue?vue&type=script&lang=ts&"
export * from "./EmptyBox.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {BaseIcon: require('/app/components/base/Icon.vue').default,BaseButton: require('/app/components/base/Button.vue').default})
